import classNames from "classnames";
import styles from "./RatingsInline.module.scss";

interface RatingsInlineProps {
  averageRating?: number;
  numberOfReviews: number;
}

export const RatingsInline = ({
  averageRating = 0,
  numberOfReviews,
}: RatingsInlineProps) => {
  if (!numberOfReviews) {
    return null;
  }

  const MAX_STARS = 5;

  const filledStars = Math.max(
    0,
    Math.min(MAX_STARS, Math.round(averageRating)),
  );

  return (
    <div
      className={styles.ratingsInline}
      data-testid="ratings-inline"
      aria-label={
        averageRating > 0
          ? `Rated ${averageRating} out of 5 stars, ${numberOfReviews} reviews`
          : `${numberOfReviews} reviews`
      }
    >
      <div className={styles.starRow} aria-hidden="true">
        {Array.from({ length: MAX_STARS }, (_, index) => {
          const isFilled = index < filledStars;

          return (
            <span
              key={`star-${index}`}
              className={classNames(styles.star, {
                [styles.starFilled!]: isFilled,
                [styles.starEmpty!]: !isFilled,
              })}
              aria-hidden="true"
            />
          );
        })}
      </div>
      <span className={styles.reviewCount}>({numberOfReviews})</span>
    </div>
  );
};
